<template>
  <div class="xn-table">
    <table>
      <thead>
        <tr>
          <th colspan="4">{{ profitDetail?profitDetail.companyName:'' }}</th>
        </tr>
        <tr>
          <th></th>
          <th>项目</th>
          <th style="width:30%">本年累计金额(元)</th>
          <th style="width:25%">本月金额(元)</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(tr,index) in tableConfig" :key="index" :class="tr.className">
          <td>{{ tr.col1 }}</td>
          <td>{{ tr.col2 }}</td>
          <td style="width:30%">{{ tr.col3 ? tr.col3.toLocaleString() : '-' }}</td>
          <td style="width:25%">{{ tr.col4 ? tr.col4.toLocaleString() : '-' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: "ProfitDetail",
    computed: {
      ...mapGetters(['profitDetail']),
      id() {
        return this.$route.params.profitId;
      },
      item() {
        return this.profitDetail || {};
      },
      tableConfig() {
        let data = [
          {className: 'bold', col1: '1', col2: '一、营业收入', col3: this.item.c1, col4: this.item.r1},
          {className: '', col1: '2', col2: '减：营业成本', col3: this.item.c2, col4: this.item.r2},
          {className: '', col1: '3', col2: '税金及附加', col3: this.item.c3, col4: this.item.r3},
          {className: '', col1: '4', col2: '其中：消费税', col3: this.item.c4, col4: this.item.r4},
          {className: '', col1: '5', col2: '营业税', col3: this.item.c5, col4: this.item.r5},
          {className: '', col1: '6', col2: '城市维护建设税', col3: this.item.c6, col4: this.item.r6},
          {className: '', col1: '7', col2: '资源税', col3: this.item.c7, col4: this.item.r7},
          {className: '', col1: '8', col2: '土地增值税', col3: this.item.c8, col4: this.item.r8},
          {className: '', col1: '9', col2: '城镇土地使用税、房产税、车船税、印花税', col3: this.item.c9, col4: this.item.r9},
          {className: '', col1: '10', col2: '教育费附加、矿产资源补偿费、排污费', col3: this.item.c10, col4: this.item.r10},
          {className: '', col1: '11', col2: '销售费用', col3: this.item.c11, col4: this.item.r11},
          {className: '', col1: '12', col2: '其中：商品维修费', col3: this.item.c12, col4: this.item.r12},
          {className: '', col1: '13', col2: '广告费和业务宣传费', col3: this.item.c13, col4: this.item.r13},
          {className: '', col1: '14', col2: '管理费用', col3: this.item.c14, col4: this.item.r14},
          {className: '', col1: '15', col2: '其中：开办费', col3: this.item.c15, col4: this.item.r15},
          {className: '', col1: '16', col2: '业务招待费', col3: this.item.c16, col4: this.item.r16},
          {className: '', col1: '17', col2: '研究费用', col3: this.item.c17, col4: this.item.r17},
          {className: '', col1: '18', col2: '财务费用', col3: this.item.c18, col4: this.item.r18},
          {className: '', col1: '19', col2: '其中：利息费用（收入以“-”号填列）', col3: this.item.c19, col4: this.item.r19},
          {className: '', col1: '20', col2: '加：投资收益（损失以“-”号填列）', col3: this.item.c20, col4: this.item.r20},
          {className: 'bold', col1: '21', col2: '二、营业利润（亏损以“-”号填列）', col3: this.item.c21, col4: this.item.r21},
          {className: '', col1: '22', col2: '加：营业外收入', col3: this.item.c22, col4: this.item.r22},
          {className: '', col1: '23', col2: '其中：政府补助', col3: this.item.c23, col4: this.item.r23},
          {className: '', col1: '24', col2: '减：营业外支出', col3: this.item.c24, col4: this.item.r24},
          {className: '', col1: '25', col2: '其中：坏账损失', col3: this.item.c25, col4: this.item.r25},
          {className: '', col1: '26', col2: '无法收回的长期债券投资损失', col3: this.item.c26, col4: this.item.r26},
          {className: '', col1: '27', col2: '无法收回的长期股权投资损失', col3: this.item.c27, col4: this.item.r27},
          {className: '', col1: '28', col2: '自然灾害等不可抗力因素造成的损失', col3: this.item.c28, col4: this.item.r28},
          {className: '', col1: '29', col2: '税收滞纳金', col3: this.item.c29, col4: this.item.r29},
          {className: 'bold', col1: '30', col2: '三、利润总额（亏损总额以“-”号填列）', col3: this.item.c30, col4: this.item.r30},
          {className: '', col1: '31', col2: '减：所得税费用', col3: this.item.c31, col4: this.item.r31},
          {className: 'bold no-border',col1: '32',col2: '四、净利润（净亏损以“-”号填列）',col3: this.item.c32,col4: this.item.r32},
        ];
        return data;
      }
    },
    methods: {
      ...mapActions(['getProfitDetail'])
    },
    watch: {
      profitDetail() {
        if (this.profitDetail) {
          let arr = this.profitDetail.month.split('-');
          window.document.title = `${arr[0]}年${arr[1]}月报表`;
        }
      }
    },
    created() {
      this.getProfitDetail(this.id);
    }
  }
</script>

<style scoped>

</style>